document.addEventListener("DOMContentLoaded", function () {
    const sections = document.querySelectorAll(".collapsible-section");

    sections.forEach((section) => {
        const footer = section.querySelector(".collapsible-section__footer");
        const body = section.querySelector(".collapsible-section__body");

        footer.addEventListener("click", function () {
            const bodyContent = body.querySelector(".collapsible-section__body-content");
            const bodyContentHeight = bodyContent.offsetHeight;
            const bodyHeight = body.offsetHeight;
            const isCurrentOpened = bodyHeight > 0;

            body.style.height = `${isCurrentOpened ? 0 : bodyContentHeight}px`;
            section.classList.toggle("collapsible-section--opened", !isCurrentOpened);

            if (isCurrentOpened) {
                const offset = 100;
                const elementPosition = section.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - offset;
                
                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });
            }
        });
    });
});